import { render, staticRenderFns } from "./PlanningsNews.vue?vue&type=template&id=b731d038&"
import script from "./PlanningsNews.vue?vue&type=script&lang=js&"
export * from "./PlanningsNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports